import { APPROVAL_TYPE, type ApprovalType } from '@/constants/approval-types';

const APPROVAL_ENTITY_TYPE_TO_TYPE: Record<string, ApprovalType> = {
  AtsJob: APPROVAL_TYPE.JOB,
  AtsOffer: APPROVAL_TYPE.OFFER,
  Requisition: APPROVAL_TYPE.REQUISITION,
};

interface ApprovalTasksResponse {
  data?: Array<{ entity?: { type?: string } } & Record<string, unknown>>;
  [key: string]: unknown;
}

/**
 * Tags each row of the unified `/tasks/approvals` list with the client-side
 * `type` (job / offer / requisition) that the approval rows switch on — the
 * per-type endpoints left that to the caller, the mixed list cannot.
 */
export const transformApprovalTasks = (response: ApprovalTasksResponse) => ({
  ...response,
  data: (response?.data ?? []).map((item) => ({
    ...item,
    type: APPROVAL_ENTITY_TYPE_TO_TYPE[item?.entity?.type ?? ''],
  })),
});
